// components/AppInner.tsx

import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

// ✅ Lives here — inside RouterProvider so useNavigate works
function PushNavigationHandler() {
  const navigate = useNavigate();
  const { token } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    if (!token || !("serviceWorker" in navigator)) return;

    const handler = (event: MessageEvent) => {
      if (event.data?.type === "PUSH_NAVIGATE") {
        navigate(event.data.link);
      }
    };

    navigator.serviceWorker.addEventListener("message", handler);
    return () =>
      navigator.serviceWorker.removeEventListener("message", handler);
  }, [token, navigate]);

  return null;
}

// ✅ Wrap everything that needs router context here
// This component is rendered as a route element inside the router tree
const AppInner = () => {
  return (
    <>
      <PushNavigationHandler />
      <Outlet />
    </>
  );
};

export default AppInner;
